import { Card, fmtDateTime } from "../_shared";
import { stableKey } from "./format";

function PathwayCard({ name, block }) {
  return (
    <div
      className="rounded-xl border border-slate-200 bg-white p-4"
      data-testid={`admin-pathway-${name}`}
    >
      <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">
        {name.replace(/_/g, " ")}
      </div>
      {block.role_title && (
        <div className="mt-1 text-base font-medium text-slate-900">
          {block.role_title}
        </div>
      )}
      {block.summary && (
        <p className="mt-2 text-sm text-slate-600 leading-relaxed whitespace-pre-wrap">
          {block.summary}
        </p>
      )}
      {Array.isArray(block.first_steps) && block.first_steps.length > 0 && (
        <div className="mt-3">
          <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
            First steps
          </div>
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-0.5">
            {block.first_steps.map((s, i) => (
              <li key={stableKey(s, `step-${i}`)}>{s}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default function AiReportCard({ ai }) {
  const pathways = ai.pathways || {};
  const isEmpty =
    !ai.version && !Object.keys(pathways).length && !ai.summary;

  return (
    <Card className="p-5 lg:col-span-3" testid="admin-assessment-ai">
      <header className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-medium text-slate-900">
          AI report &amp; feedback
        </h2>
        {ai.generated_at && (
          <span className="text-xs text-slate-500">
            Generated {fmtDateTime(ai.generated_at)}
            {ai.version ? ` · v${ai.version}` : ""}
          </span>
        )}
      </header>

      {ai.summary && (
        <div
          className="mb-4 rounded-xl bg-slate-50 border border-slate-200 px-4 py-3 text-sm text-slate-700 leading-relaxed whitespace-pre-wrap"
          data-testid="admin-ai-summary"
        >
          {ai.summary}
        </div>
      )}

      {isEmpty && (
        <p
          className="text-sm text-slate-500"
          data-testid="admin-assessment-ai-empty"
        >
          No AI report yet — click <strong>Rerun AI</strong> above.
        </p>
      )}

      {Object.keys(pathways).length > 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {Object.entries(pathways).map(([k, p]) => {
            if (!p) return null;
            const block =
              typeof p === "string"
                ? { role_title: null, summary: p }
                : p;
            return <PathwayCard key={k} name={k} block={block} />;
          })}
        </div>
      )}

      {ai.providers_meta && (
        <div
          className="mt-5 flex flex-wrap gap-2"
          data-testid="admin-assessment-providers"
        >
          {Object.entries(ai.providers_meta).map(([name, m]) => (
            <span
              key={name}
              className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] ${
                m.mocked
                  ? "border-amber-200 bg-amber-50 text-amber-800"
                  : "border-emerald-200 bg-emerald-50 text-emerald-700"
              }`}
            >
              {name}: {m.mocked ? "mocked" : "live"}
              {m.error ? " · error" : ""}
            </span>
          ))}
        </div>
      )}
    </Card>
  );
}
